<template>
  <v-card>
    <v-card-title primary-title style="padding-left: 8px; padding-bottom: 8px">
      <span class="headline mb-0">{{ $t('B0300.titles[3]') }}</span>
    </v-card-title>
    <v-card-actions>
      <v-btn
        :disabled="selected.length == 0 || invoice.isUsed == true"
        @click="splitPackage"
        small
        v-if="editable"
        >{{ $t('app.buttons.splitPackage') }}</v-btn
      >
      <v-btn
        :disabled="selected.length == 0 || invoice.isUsed == true"
        @click="removePackages"
        small
        v-if="editable"
        >{{ $t('app.buttons.remove') }}</v-btn
      >
      <!-- <v-btn
        :disabled="selected.length==0 || invoice.isUsed==true"
        @click="updateSkuWeight"
        small
      >重量登録</v-btn>-->
      <v-btn @click="calNGM">容積重量</v-btn>
      <v-spacer></v-spacer>

      <v-text-field
        :disabled="!hasPackages"
        label="Total N/W"
        v-model.number="invoice.nw"
      ></v-text-field>
      <v-text-field
        :disabled="!hasPackages"
        label="Total G/W"
        v-model.number="invoice.gw"
      ></v-text-field>
      <v-text-field
        :disabled="!hasPackages"
        label="Total M/3"
        v-model.number="invoice.m3"
      ></v-text-field>
    </v-card-actions>
    <v-data-table
      :headers="headers"
      :items="invoice.packages"
      :rows-per-page-items="[10]"
      class="elevation-1 pb-2 inline-edit"
      item-key="seq"
      select-all
      v-model="selected"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>
            <v-checkbox
              :disabled="invoice.isUsed == true"
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.poNo }}</td>
          <td>{{ props.item.skuCode }}</td>
          <td>{{ props.item.productCode }}</td>
          <td>
            <v-text-field
              :disabled="!editable"
              :placeholder="$t('app.labels.package.flag')"
              clearable
              v-model="props.item.flag"
            />
          </td>
          <td>
            <v-text-field
              :disabled="!editable"
              @change="onchange(props.item)"
              clearable
              v-model.number="props.item.cartonStartNo"
            />
          </td>
          <td>
            <v-text-field
              :disabled="!editable"
              @change="onchange(props.item)"
              clearable
              v-model.number="props.item.cartonEndNo"
            />
          </td>
          <td>
            <v-text-field
              :disabled="!editable"
              :placeholder="$t('app.labels.package.perCartonQty')"
              :rules="[(v) => !hasPoint(v) || '整数にご修正ください。']"
              clearable
              v-model="props.item.perCartonQty"
            />
          </td>
          <td>
            <v-text-field
              :disabled="!editable"
              :placeholder="$t('app.labels.qty')"
              :rules="[(v) => !hasPoint(v) || '整数にご修正ください。']"
              @change="qtyChange(props.item)"
              clearable
              v-model.number="props.item.totalQty"
            />
          </td>
          <td>
            <v-text-field
              :disabled="!editable"
              @change="clearNum(props.item)"
              clearable
              type="number"
              v-model.number="props.item.totalNetWeight"
            />
          </td>

          <td>
            <v-text-field
              :disabled="!editable"
              @change="clearNum(props.item)"
              clearable
              type="number"
              v-model.number="props.item.totalGrossWeight"
            />
          </td>

          <td>
            <v-text-field
              :disabled="!editable"
              @change="clearNum(props.item)"
              clearable
              type="number"
              v-model.number="props.item.totalVolume"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  props: ['invoice'],
  data() {
    return {
      selected: [],
      uploadData: [],
      standardNGV: [],
      headers: [
        { text: this.$t('app.labels.poNo'), value: 'poNo', sortable: false },
        {
          text: this.$t('app.labels.skuCode'),
          value: 'skuCode',
          sortable: false,
        },
        {
          text: this.$t('app.labels.productCode'),
          value: 'productCode',
          sortable: false,
        },
        {
          text: this.$t('app.labels.package.flag'),
          value: 'flag',
          sortable: false,
        },
        {
          text: this.$t('app.labels.package.cartonStartNo'),
          value: 'cartonStartNo',
          sortable: false,
        },
        {
          text: this.$t('app.labels.package.cartonEndNo'),
          value: 'cartonEndNo',
          sortable: false,
        },
        {
          text: this.$t('app.labels.package.perCartonQty'),
          value: 'perCartonQty',
          sortable: false,
        },
        {
          text: this.$t('app.labels.qty'),
          value: 'totalQty',
          sortable: false,
        },
        {
          text: this.$t('app.labels.package.netWeight'),
          value: 'totalNetWeight',
          sortable: false,
        },
        {
          text: this.$t('app.labels.package.grossWeight'),
          value: 'totalGrossWeight',
          sortable: false,
        },
        {
          text: this.$t('app.labels.package.volume'),
          value: 'totalVolume',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    subTotal(item) {
      return Math.round(item.unitPrice * item.qty * 100) / 100
    },
    NGMSubTotal(item) {
      return Math.round(item.unitPrice * item.qty * 1000000) / 1000000
    },
    calNGM() {
      this.invoice.packages.forEach((p) => {
        var percent =
          Math.round(p.unitPrice * p.totalQty * 1000000) /
          1000000 /
          this.NGMtotal
        p.totalNetWeight = Math.round(percent * this.invoice.nw * 100) / 100

        p.totalGrossWeight = Math.round(percent * this.invoice.gw * 100) / 100

        p.totalVolume = Math.round(percent * this.invoice.m3 * 1000) / 1000
      })
      this.$forceUpdate()
      this.initNGVData()
      console.log('updated')
    },
    keydown(e) {
      var allowKeys = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '.',
        'Backspace',
      ]
      var key = e.key
      if (key === '.' && e.target.value.indexOf(key) > 0) {
        e.preventDefault()
      } else if (allowKeys.indexOf(key) < 0) {
        e.preventDefault()
      }
    },
    changeTotal() {
      if (this.invoice.totalNw)
        this.invoice.totalNw = this.$numberScale2(this.invoice.totalNw)
      if (this.invoice.totalGw)
        this.invoice.totalGw = this.$numberScale2(this.invoice.totalGw)

      if (this.invoice.totalM3)
        this.invoice.totalM3 = this.$numberScale3(this.invoice.totalM3)
      this.$forceUpdate()
    },
    clearNum(item) {
      if (item.totalNetWeight)
        item.totalNetWeight = this.$numberScale2(item.totalNetWeight)
      if (item.totalGrossWeight)
        item.totalGrossWeight = this.$numberScale2(item.totalGrossWeight)
      if (item.totalVolume)
        item.totalVolume = this.$numberScale3(item.totalVolume)
      this.initNGVData()
    },
    hasPoint(x) {
      console.log(x)
      var y = String(x).indexOf('.') + 1 //获取小数点的位置
      if (y > 0) {
        return true
      } else {
        return false
      }
    },
    canEdit(item) {
      item.totalQty / (item.cartonEndNo - item.cartonStartNo + 1) !=
        item.perCartonQty && this.hasPoint(item.perCartonQty)
    },
    updateSkuWeight() {
      this.selected.forEach((pkg) => {
        this.$http
          .put(`skus/update/weight`, pkg)
          .then(this.$message('', this.$t('app.messages.saveSuccess'))) //'完了しました'
          .catch((res) => {
            console.log(res.response.status)
            if (res.response.status == '412') {
              this.$message(
                this.$t('app.messages.errors.title'),
                this.$t('B0300.messages.errors.hugeQty')
              )
            }
            if (res.response.status == '409') {
              this.$message(
                this.$t('app.messages.errors.title'),
                this.$t('B0300.messages.errors.ivNoExist')
              )
            }
            if (res.response.status == '500') {
              this.$message(
                this.$t('app.messages.errors.title'),
                this.$t('app.system.error')
              ) //'System Error'
            }
          })
      })
    },
    canPackageAdd(data) {
      var poNos = []
      var itemPoNos = []
      for (var i = 1; i < data.length; i++) {
        if (poNos.indexOf(data[i][0]) == -1) {
          poNos.push(data[i][0])
        }
      }
      this.invoice.items
        .map((i) => i.poNo)
        .forEach((item) => {
          if (itemPoNos.indexOf(item)) {
            itemPoNos.push(item)
          }
        })
      console.log(poNos)
      console.log(itemPoNos)
      if (poNos.length <= itemPoNos.length) {
        return true
      } else {
        return false
      }
    },
    calMax(item) {
      return (v) =>
        (v > 0 && v <= this.findMax(item)) ||
        this.$t('B0300.messages.errors.invalidQty', {
          qty: this.findMax(item),
        })
    },
    findMax(item) {
      if (this.invoice.purchaseOrder != null) {
        return Number(
          this.invoice.purchaseOrder.filter((p) => {
            return p.poNo == item.poNo
          })[0].leftInvoice
        )
      }
    },
    onchange(item) {
      if (
        item.cartonStartNo != null &&
        item.cartonEndNo != null &&
        item.totalQty != null
      ) {
        if (item.cartonEndNo - item.cartonStartNo + 1 != 0) {
          this.$set(item, 'perCartonQty', this.perCarton(item))
        }
      }
      this.$forceUpdate()
    },

    qtyChange(item) {
      this.calNewNGV(item)
      this.onchange(item)
    },

    changeTotalQty(item) {
      item.totalQty =
        (item.cartonEndNo - item.cartonStartNo + 1) * item.perCartonQty
    },
    perCarton(item) {
      // return Math.ceil(
      return item.totalQty / (item.cartonEndNo - item.cartonStartNo + 1)
      // )
    },
    initNGVData() {
      var pkgs = this.invoice.packages
      pkgs.forEach((pkg) => {
        //只有一个的时候才赋标准
        if (pkgs.filter((p) => p.poNo === pkg.poNo).length === 1) {
          var data = this.standardNGV.find((s) => s.poNo === pkg.poNo)

          if (!data) {
            //创建标准
            this.standardNGV.push({
              poNo: pkg.poNo,
              totalNetWeight: pkg.totalNetWeight,
              totalGrossWeight: pkg.totalGrossWeight,
              totalVolume: pkg.totalVolume,
              totalQty: pkg.totalQty,
            })
          } else {
            //更新标准
            data.poNo = pkg.poNo
            data.totalNetWeight = pkg.totalNetWeight
            data.totalGrossWeight = pkg.totalGrossWeight
            data.totalVolume = pkg.totalVolume
            data.totalQty = pkg.totalQty
          }
        }
      })
    },
    splitPackage() {
      console.log(this.standardNGV)
      this.invoice.packages = this.invoice.packages
        .reduce((t, p) => {
          t.push(p)
          if (this.selected.indexOf(p) !== -1) {
            t.push({
              ...p,
              id: null,
              totalNetWeight: 0,
              totalGrossWeight: 0,
              totalVolume: 0,
            })
          }
          return t
        }, [])
        .map((p, idx) => ({ ...p, seq: idx }))
      this.selected = []
    },
    calNewNGV(item) {
      var standard = this.standardNGV.find((s) => s.poNo === item.poNo)

      if (standard != null) {
        var percent =
          Math.round(item.totalQty * 1000000) / 1000000 / standard.totalQty

        item.totalNetWeight =
          Math.round(percent * standard.totalNetWeight * 100) / 100

        item.totalGrossWeight =
          Math.round(percent * standard.totalGrossWeight * 100) / 100

        item.totalVolume =
          Math.round(percent * standard.totalVolume * 1000) / 1000
      }
      this.checkNGV()
    },
    checkNGV() {
      this.standardNGV.forEach((standard) => {
        var totalGrossWeight = this.invoice.packages
          .filter((p) => p.poNo === standard.poNo)
          .reduce((t, p) => {
            return t + p.totalGrossWeight
          }, 0)
        var totalNetWeight = this.invoice.packages
          .filter((p) => p.poNo === standard.poNo)
          .reduce((t, p) => {
            return t + p.totalNetWeight
          }, 0)
        var totalVolume = this.invoice.packages
          .filter((p) => p.poNo === standard.poNo)
          .reduce((t, p) => {
            return t + p.totalVolume
          }, 0)

        var totalQty = this.invoice.packages
          .filter((p) => p.poNo === standard.poNo)
          .reduce((t, p) => {
            return t + p.totalQty
          }, 0)

        if (Number(totalQty) === Number(standard.totalQty)) {
          var firstPkg = this.invoice.packages.find(
            (p) => p.poNo === standard.poNo
          )
          if (Number(standard.totalGrossWeight) !== Number(totalGrossWeight)) {
            console.log('total gross weight not equal')
            firstPkg.totalGrossWeight =
              Math.round(
                (firstPkg.totalGrossWeight +
                  Number(standard.totalGrossWeight) -
                  Number(totalGrossWeight)) *
                  100
              ) / 100
          }
          if (Number(standard.totalNetWeight) !== Number(totalNetWeight)) {
            console.log('total net weight not equal')
            firstPkg.totalNetWeight =
              Math.round(
                (firstPkg.totalNetWeight +
                  Number(standard.totalNetWeight) -
                  Number(totalNetWeight)) *
                  100
              ) / 100
          }
          if (Number(standard.totalVolume) !== Number(totalVolume)) {
            console.log('total volume not equal')
            firstPkg.totalVolume =
              Math.round(
                (firstPkg.totalVolume +
                  Number(standard.totalVolume) -
                  Number(totalVolume)) *
                  1000
              ) / 1000
          }
        }
      })
    },
    removePackages() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          this.invoice.packages = this.invoice.packages.filter(
            (pkg) => this.selected.indexOf(pkg) === -1
          )
          this.selected = []
          this.$message('', this.$t('app.messages.removeSuccess'))
        }
      )
    },
    hasPointLessThan2(x) {
      var y = String(x).indexOf('.') + 1 //获取小数点的位置
      if (y > 2) {
        return ['number cannot exceed two decimal places']
      } else {
        return [x]
      }
    },
    hasPointLessThan3(x) {
      var y = String(x).indexOf('.') + 1 //获取小数点的位置
      if (y > 3) {
        return 'number cannot exceed two decimal places'
      } else {
        return x
      }
    },
    checkSkuAndPerCarton(item) {
      if (item && item.perCartonQty && item.skuCode) {
        this.$http
          .get(
            `/commercial-invoices/findSku/${item.skuCode}/${item.perCartonQty}`
          )
          .then((res) => {
            console.log(res.data)
            this.$set(item, 'totalNetWeight', res.data.unitNetWeight)
            this.$set(item, 'totalGrossWeight', res.data.boxWeight)
            this.$set(item, 'totalVolume', res.data.boxVolume)
          })
      }
      this.changeTotalQty(item)
    },
  },

  mounted() {},
  computed: {
    total() {
      return this.invoice.items
        .filter((i) => i.qty != null && i.unitPrice != null)
        .reduce((t, i) => t + this.subTotal(i), 0)
    },
    NGMtotal() {
      return this.invoice.items
        .filter((i) => i.qty != null && i.unitPrice != null)
        .reduce((t, i) => t + this.NGMSubTotal(i), 0)
    },
    hasPackages() {
      return this.invoice.packages.length > 0
    },
    editable() {
      return (
        this.invoice &&
        (this.invoice.isUsed == null || this.invoice.isUsed == false)
      )
    },
  },
}
</script>

